import omit from 'lodash/omit';
import { isAppleDevice, normalizeKeyCombinations, normativeOrderKeyCombinations, } from 'utils/keyboard';
import { commandGroupDelimiter } from '../utils/commandUtils';
const osKeybindingsKey = isAppleDevice
    ? 'keybindings_mac'
    : 'keybindings_pc';
/**
 * Creates a command definition.
 *
 * @param command The command to create.
 * @remark This function should not be used at runtime as what it produces is
 * required to be static.
 */
export function createCommand(command) {
    var _a, _b, _c;
    const name = `${command.group}${commandGroupDelimiter}${command.name}`;
    const keybindings = ((_b = (_a = command.keyboard) === null || _a === void 0 ? void 0 : _a[osKeybindingsKey]) !== null && _b !== void 0 ? _b : (_c = command.keyboard) === null || _c === void 0 ? void 0 : _c.keybindings);
    return Object.assign({ group: command.group, name, label: command.label, description: command.description, useRegisterHandler: command.useRegisterHandler }, (command.keyboard && keybindings
        ? {
            keyboard: Object.assign(Object.assign({}, omit(command.keyboard, [
                'keybindings_mac',
                'keybindings_pc',
            ])), { 
                // Normalize and order the key combinations to ensure that it is not
                // necessary to do anywhere else down the line.
                keybindings: normativeOrderKeyCombinations(normalizeKeyCombinations(keybindings)) }),
        }
        : {}));
}
